/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./AdminDSR.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FiEdit2, FiTrash2, FiPlus } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import axios from "axios";
import { Apiurl, GetToken, RemoveUserSession, downloadFile, downloadMultipleFiles } from "../../../Utils/utils";
import { Modal } from "react-bootstrap";
import { AiOutlineEye, AiOutlineDownload } from "react-icons/ai";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const AdminDSR = () => {
    const LoginToken = GetToken();
    const navigate = useNavigate();
    const [showSidebar, setShowSidebar] = useState(true);
    const [activeTab, setActiveTab] = useState("home");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectFilter, setSelectFilter] = useState("name");
    const [projects, setProjects] = useState([]);
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [loadingEmployees, setLoadingEmployees] = useState(false);
    const [monthlyReportData, setMonthlyReportData] = useState([]);
    const [reportFilters, setReportFilters] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
        userId: ""
    });
    const [loadingReport, setLoadingReport] = useState(false);
    const [taskList, setTaskList] = useState([]);
    const [filteredTaskList, setFilteredTaskList] = useState([]);
    const [taskSearch, setTaskSearch] = useState("");
    const [loadingTasks, setLoadingTasks] = useState(false);
    const [taskModalData, setTaskModalData] = useState({})
    const [employeeDsrData, setEmployeeDsrData] = useState([]);
    const [loadingEmployeeDsr, setLoadingEmployeeDsr] = useState(false);
    const [dsrFilters, setDsrFilters] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
        userId: ""
    });

    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("");
    const [editingItem, setEditingItem] = useState(null);
    const [formData, setFormData] = useState({});
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [showTaskModal, setShowTaskModal] = useState(false);
    const [projectTypes, setProjectTypes] = useState([]);
    const [loadingTypes, setLoadingTypes] = useState(false);
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [notesUrl, setNotesUrl] = useState("");
    const [showDocsModal, setShowDocsModal] = useState(false);
    const [docsList, setDocsList] = useState([]);



    const FILE_PREFIX = "https://attendanceapi.elitewebdemo.com";

    const handleViewNotes = (notesUrl) => {
        setNotesUrl(notesUrl ? (notesUrl.startsWith('http') ? notesUrl : FILE_PREFIX + notesUrl) : "");
        setShowNotesModal(true);
    };

    // const handleDownloadNotes = (notesUrl) => {
    //     if (!notesUrl) return;
    //     const fileName = notesUrl.substring(notesUrl.lastIndexOf("/") + 1);
    //     downloadFile(notesUrl, fileName);
    // };
   const handleDownloadNotes = (notesUrl) => {
  if (!notesUrl) return;

  const fullUrl = notesUrl.startsWith("http")
    ? notesUrl
    : FILE_PREFIX + notesUrl;

  const fileName = fullUrl.split("/").pop();

  downloadFile(fullUrl, fileName);
};


    const handleViewDocs = (docs) => {
        if (!docs || docs.length === 0) {
            toast.error("No documents available");
            return;
        }

        const formattedDocs = docs
            .filter(doc => doc.ProjectDoument)
            .map(doc => {
                const fullUrl = doc.ProjectDoument.startsWith("http")
                    ? doc.ProjectDoument
                    : FILE_PREFIX + doc.ProjectDoument;

                return {
                    url: fullUrl,
                    fileName: doc.ProjectDoument.split("\\").pop().split("/").pop()
                };
            });

        setDocsList(formattedDocs);
        setShowDocsModal(true);
    };

    const handleDownloadAllDocuments = (docsArr) => {
        if (!docsArr || docsArr.length === 0) {
            toast.error("No documents available");
            return;
        }

        const files = docsArr
            .filter(doc => doc.ProjectDoument)
            .map(doc => {
                const fullUrl = doc.ProjectDoument.startsWith("http")
                    ? doc.ProjectDoument
                    : FILE_PREFIX + doc.ProjectDoument;

                return {
                    url: fullUrl,
                    fileName: doc.ProjectDoument.split("\\").pop().split("/").pop()
                };
            });

        if (files.length > 0) {
            downloadMultipleFiles(files);
        } else {
            toast.error("No documents available");
        }
    };

    const handlePreviewSingleDoc = (url) => {
        window.open(url, "_blank");
    };

    const handleDownloadSingleDoc = (url, fileName) => {
        downloadFile(url, fileName);
    };

    useEffect(() => {
        if (window.innerWidth < 600) {
            const timeoutId = setTimeout(() => {
                setShowSidebar(false);
            }, 1000);
            return () => clearTimeout(timeoutId);
        }
        setShowSidebar(true);
    }, []);

    const formatTime = (hours, minutes) => {
        const h = hours?.split(":")[0] || "00";
        const m = minutes?.split(":")[1] || "00";
        return `${h} h ${m} m`;
    };

    const fetchProjectTypes = () => {
        setLoadingTypes(true);
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `${Apiurl()}/Projects/GetAllProjectTypes`,
        };
        axios(option)
            .then((response) => {
                if (response?.data?.success) {
                    const parsedData = JSON.parse(response?.data?.data);
                    setProjectTypes(parsedData);
                }
                setLoadingTypes(false);
            })
            .catch((error) => {
                setLoadingTypes(false);
                if (error?.response?.status === 401) {
                    toast.error("Your session has expired");
                    RemoveUserSession();
                    navigate("/", { replace: true });;
                } else {
                    toast.error("Failed to fetch project types");
                }
            });
    };

    const fetchProjects = () => {
        setLoadingProjects(true);

        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `${Apiurl()}/Projects/GetAllProjects`,
        };

        axios(option)
            .then((response) => {
                if (response?.data?.success) {
                    const parsed = JSON.parse(response.data.data || "{}");

                    const projectsArray = parsed?.Data || [];

                    const employeeMap = Object.fromEntries(
                        employees.map(e => [Number(e.id), e.name])
                    );

                    const formattedProjects = projectsArray.map((item) => ({
                        id: item.Project?.ProjectId,
                        name: item.Project?.ProjectName,
                        type: item.Project?.ProjectTypeNavigation?.ProjectType1 || "",
                        projectTypeId: item.Project?.ProjectType,
                        assignedUserId: item.Project?.AssignedUserId || "",
                        assignedUserName:
                            employeeMap[Number(item.Project?.AssignedUserId)] || "",
                        projectNotesFile: item.Project?.ProjectNotesFile || "",
                        // projectDocuments: item.Project?.TblProjectDocuments || []
                   projectDocuments: item.Documents || []
                    }));

                    setProjects(formattedProjects);
                }

                setLoadingProjects(false);
            })
            .catch((error) => {
                setLoadingProjects(false);

                if (error?.response?.status === 401) {
                    toast.error("Your session has expired");
                    RemoveUserSession();
                    navigate("/", { replace: true });;
                } else {
                    toast.error("Failed to fetch projects");
                }
            });
    };

    const fetchEmployees = () => {
        setLoadingEmployees(true);
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `${Apiurl()}/Admin/GetAllEmployees`,
        };

        axios(option)
            .then((response) => {
                if (response?.data?.success) {
                    const firstParse = JSON.parse(response?.data?.data);
                    const formattedEmployees = firstParse.map((item) => ({
                        id: item.UserId,
                        name: `${item.FirstName || ""} ${item.LastName || ""}`.trim()
                    }));

                    setEmployees(formattedEmployees);
                }
                setLoadingEmployees(false);
            })
            .catch((error) => {
                setLoadingEmployees(false);
                if (error?.response?.status === 401) {
                    toast.error("Your session has expired");
                    RemoveUserSession();
                    navigate("/", { replace: true });;
                } else {
                    toast.error("Failed to fetch employees");
                }
            });
    };

    const fetchMonthlyReport = () => {
        const { fromDate, toDate, projectId, userId } = reportFilters;
        if (!fromDate || !toDate) {
            toast.error("From Date and To Date are required");
            return;
        }

        if (!projectId && !userId) {
            toast.error("Please select at least Project or Employee");
            return;
        }
        setMonthlyReportData([]);
        setLoadingReport(true);
        const payload = {
            data: JSON.stringify({
                FromDate: fromDate,
                ToDate: toDate,
                ProjectId: projectId || "0",
                UserId: userId || "0"
            })
        };

        const option = {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `${Apiurl()}/Task/GetMonthlyReport`,
            data: payload,
        };

        axios(option)
            .then((response) => {
                if (response?.data?.success) {
                    const parsedData = JSON.parse(response?.data?.data || "[]");

                    if (!parsedData.length) {
                        setMonthlyReportData([]);
                        toast.error("No record found");
                        setLoadingReport(false);
                        return;
                    }
                    setMonthlyReportData(parsedData || []);
                } else {
                    setMonthlyReportData([]);
                    toast.error("No record found");
                }
                setLoadingReport(false);
            })
            .catch((error) => {
                setLoadingReport(false);
                if (error?.response?.status === 401) {
                    toast.error("Your session has expired");
                    RemoveUserSession();
                    navigate("/", { replace: true });;
                } else {
                    toast.error("Failed to fetch report");
                }
            });
    };

    const fetchTasksForAdmin = (rowData) => {
        const { fromDate, toDate } = reportFilters;
        if (!fromDate || !toDate) {
            toast.error("From Date and To Date are required");
            return;
        }
        const projectId = rowData.ProjectId || rowData.projectId;
        const userId = rowData.UserId || rowData.userId;
        if (!projectId || !userId) {
            toast.error("ProjectId or UserId missing in row data");
            return;
        }
        setLoadingTasks(true);
        setTaskModalData({
            projectName: rowData.ProjectName,
            employeeName: rowData.UserName
        });

        const payload = {
            data: JSON.stringify({
                FromDate: fromDate,
                ToDate: toDate,
                ProjectId: projectId,
                UserId: userId
            })
        };
        const option = {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `${Apiurl()}/Task/GetTasksForAdminByUser`,
            data: payload,
        };
        axios(option)
            .then((response) => {
                if (response?.data?.success) {
                    const parsedData = JSON.parse(response?.data?.data);
                    const formattedTasks = parsedData.map((item) => ({
                        id: item.Id,
                        date: item.Date?.split("T")[0],
                        task: item.TaskDetail,
                        time: formatTime(item.Hours, item.Minutes)
                    }));

                    setTaskList(formattedTasks);
                    setFilteredTaskList(formattedTasks);
                    setTaskSearch("");
                    setShowTaskModal(true);
                } else {
                    toast.error("No tasks found");
                }
                setLoadingTasks(false);
            })
            .catch(() => {
                setLoadingTasks(false);
                toast.error("Failed to fetch tasks");
            });
    };

    const fetchEmployeeDsr = () => {
        const { fromDate, toDate, projectId, userId } = dsrFilters;
        if (!userId) {
            toast.error("Employee is required");
            return;
        }
        setEmployeeDsrData([]);
        setLoadingEmployeeDsr(true);
        let requestData = {
            UserId: userId,
            ...(fromDate && toDate && { FromDate: fromDate, ToDate: toDate }),
            ...(projectId && { ProjectId: projectId })
        };
        const payload = {
            data: JSON.stringify(requestData)
        };
        axios({
            method: "POST",
            url: `${Apiurl()}/Task/GetTasksForAdminByUser`,
            headers: {
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`
            },
            data: payload
        })
            .then((response) => {
                if (response?.data?.success) {
                    const parsedData = JSON.parse(response?.data?.data || "[]");

                    if (!parsedData || parsedData.length === 0) {
                        setEmployeeDsrData([]);
                        toast.error("No record found");
                        setLoadingEmployeeDsr(false);
                        return;
                    }
                    const formatted = parsedData.map((item) => ({
                        id: item.Id,
                        date: item.Date?.split("T")[0],
                        employee: employees.find(e => Number(e.id) === Number(item.UserId))?.name || "",
                        project: item.Project?.ProjectName || "",
                        task: item.TaskDetail,
                        hours: formatTime(item.Hours, item.Minutes)
                    }));
                    setEmployeeDsrData(formatted);
                } else {
                    setEmployeeDsrData([]);
                    toast.error("No record found");
                }
                setLoadingEmployeeDsr(false);
            })
            .catch(() => {
                setLoadingEmployeeDsr(false);
                toast.error("Failed to fetch data");
            });
    };

    const handleDeleteTask = (id) => {
        const payloadString = `{'Id':'${id}'}`;
        const option = {
            method: "POST",
            headers: {
                authorization: `Bearer ${LoginToken}`,
                "content-type": "application/json",
            },
            url: `${Apiurl()}/Task/DeleteTask`,
            data: {
                data: payloadString,
            },
        };
        axios(option)
            .then(() => {
                toast.success("Task deleted successfully");
                setEmployeeDsrData(prev =>
                    prev.filter(item => item.id !== id)
                );
                setShowDeleteModal(false);
                setDeleteId(null);
            })
            .catch(() => {
                toast.error("Failed to delete task");
                setShowDeleteModal(false);
            });
    };

    const formatToBackendTime = (value, type) => {
        const num = Number(value || 0);
        if (type === "hour") {
            return `${String(num).padStart(2, "0")}:00:00`;
        }
        if (type === "minute") {
            return `00:${String(num).padStart(2, "0")}:00`;
        }
        return "00:00:00";
    };

    const handleUpdateTask = () => {
        if (!formData.date || !formData.projectId || !formData.task) {
            toast.error("Please fill all required fields");
            return;
        }
        const formattedHours = formatToBackendTime(formData.hours, "hour");
        const formattedMinutes = formatToBackendTime(formData.minutes, "minute");
        const payloadString = `{
        'Id':'${formData.Id}',
        'Date':'${formData.date}',
        'ProjectId':'${formData.projectId}',
        'UserId':'${formData.userId}',
        'Hours':'${formattedHours}',
        'Minutes':'${formattedMinutes}',
        'TaskDetail':'${formData.task}'
    }`;
        axios({
            method: "POST",
            url: `${Apiurl()}/Task/SaveTaskDetail`,
            headers: {
                authorization: `Bearer ${LoginToken}`,
                "content-type": "application/json",
            },
            data: {
                data: payloadString,
            },
        })
            .then(() => {
                toast.success("Task updated successfully");
                setEmployeeDsrData(prev =>
                    prev.map(item =>
                        item.id === formData.Id
                            ? {
                                ...item,
                                date: formData.date,
                                project: projects.find(p => p.id === Number(formData.projectId))?.name || "",
                                task: formData.task,
                                hours: `${formData.hours} h ${formData.minutes} m`
                            }
                            : item
                    )
                );

                closeModal();
            })
            .catch(() => {
                toast.error("Failed to update task");
            });
    };

    useEffect(() => {
        fetchProjectTypes();
        fetchEmployees();
    }, []);

    useEffect(() => {
        if (employees.length > 0) {
            fetchProjects();
        }
    }, [employees]);

    useEffect(() => {
        if (activeTab !== "home") return;

        if (!searchTerm.trim()) {
            setFilteredData([]);
            return;
        }

        const filtered = projects.filter((item) => {
            let value = "";

            if (selectFilter === "name") {
                value = item.name;
            } else if (selectFilter === "type") {
                value = item.type;
            } else if (selectFilter === "assignedUser") {
                value = item.assignedUserName;
            }

            return value?.toLowerCase().includes(searchTerm.toLowerCase());
        });
        setFilteredData(filtered);
    }, [searchTerm, selectFilter, projects, activeTab]);

    const openModal = (type, item = null) => {
        setModalType(type);
        setEditingItem(item);
        if (type === "addProject" && item) {
            setFormData({
                Id: item.id,
                ProjectName: item.name,
                ProjectType: item.projectTypeId,
                AssignedUserId: item.assignedUserId,
                ExistingProjectNotesFile: item.projectNotesFile || "",
                ExistingProjectDocuments: item.projectDocuments || [],
                ProjectNoteHtmlContent: "",
                ProjectDocumentsFiles: []
            });
        } else if (type === "editDSR" && item) {
            const [h = "0"] = item.hours?.split(" ")[0]?.split("h") || [];
            const minutesPart = item.hours?.split(" ")[2] || "0";
            setFormData({
                Id: item.id,
                date: item.date,
                projectId: projects.find(p => p.name === item.project)?.id || "",
                projectName: item.project,
                employeeName: item.employee,
                userId: employees.find(e => e.name === item.employee)?.id || "",
                hours: h.trim(),
                minutes: minutesPart.trim(),
                task: item.task
            });
        } else {
            setFormData({});
        }
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setFormData({});
        setEditingItem(null);
    };

    const handleFormSubmit = (clicked) => {
        if (modalType === "addProject") {
            if (!formData.ProjectName || !formData.ProjectType || !formData.AssignedUserId) {
                toast.error("Please fill all fields");
                return;
            }
            const formDataPayload = new FormData();

            formDataPayload.append(
                "ProjectId",
                editingItem ? String(formData.Id) : "0"
            );

            formDataPayload.append("ProjectName", formData.ProjectName);
            formDataPayload.append("ProjectType", formData.ProjectType);
            formDataPayload.append(
                "AssignedUserId",
                formData.AssignedUserId || ""
            );

            if (formData.ProjectNoteHtmlContent) {
                const blob = new Blob(
                    [formData.ProjectNoteHtmlContent],
                    { type: "text/html" }
                );

                const htmlFile = new File(
                    [blob],
                    `${formData.ProjectName || "project-notes"}.html`,
                    { type: "text/html" }
                );

                formDataPayload.append("ProjectNoteHtmlFile", htmlFile);
            }

            if (formData.ProjectDocumentsFiles && formData.ProjectDocumentsFiles.length > 0) {
                formData.ProjectDocumentsFiles.forEach((file) => {
                    formDataPayload.append("ProjectDocumentsFiles", file);
                });
            }
            const option = {
                method: "POST",
                headers: {
                    // "access-control-allow-origin": "*",
                    authorization: `Bearer ${LoginToken}`,
                },
                url: `${Apiurl()}/Projects/SaveProjectDsr`,
                data: formDataPayload,
            };
            axios(option)
                .then((response) => {

                    if (response?.data?.success) {
                        toast.success("Project saved successfully");
                        closeModal();
                        fetchProjects();
                    } else {
                        toast.error("Something went wrong");
                    }
                })
                .catch((error) => {
                    if (error?.response?.status === 401) {
                        toast.error("Your session has expired");
                        RemoveUserSession();
                        navigate("/", { replace: true });;
                    } else {
                        toast.error("Error saving project");
                    }
                });
        }
    };

    const handleDeleteConfirm = () => {
        if (deleteId) {
            handleDeleteTask(deleteId);
        }
    };

    const handleDeleteCancel = () => {
        setShowDeleteModal(false);
        setDeleteId(null);
    };

    let displayData = [];
    if (activeTab === "home") {
        displayData = searchTerm ? filteredData : projects;
    }

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setSearchTerm("");
        setFilteredData([]);
        setMonthlyReportData([]);
        setEmployeeDsrData([]);
        setTaskList([]);
        setFilteredTaskList([]);
        setTaskSearch("");
        setReportFilters({
            fromDate: "",
            toDate: "",
            projectId: "",
            userId: ""
        });
        setDsrFilters({
            fromDate: "",
            toDate: "",
            projectId: "",
            userId: ""
        });
        closeModal();
    };

    const handleReportReset = () => {
        setReportFilters({
            fromDate: "",
            toDate: "",
            projectId: "",
            userId: ""
        });

        setMonthlyReportData([]);
    };

    const handleDsrReset = () => {
        setDsrFilters({
            fromDate: "",
            toDate: "",
            projectId: "",
            userId: ""
        });

        setEmployeeDsrData([]);
    };

    const calculateTotalTime = () => {
        if (!monthlyReportData.length) return "0 h 0 m";

        let totalMinutes = 0;

        monthlyReportData.forEach(item => {
            const time = item.TotalTime || "0 h 0 m";

            const hoursMatch = time.match(/(\d+)\s*h/);
            const minutesMatch = time.match(/(\d+)\s*m/);

            const hours = hoursMatch ? parseInt(hoursMatch[1]) : 0;
            const minutes = minutesMatch ? parseInt(minutesMatch[1]) : 0;

            totalMinutes += (hours * 60) + minutes;
        });

        const finalHours = Math.floor(totalMinutes / 60);
        const finalMinutes = totalMinutes % 60;

        return `${finalHours} h ${finalMinutes} m`;
    };

    return (
        <>
            <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
            <div className="d-flex">
                <Sidebar showSidebar={showSidebar} />
                <div
                    className={
                        showSidebar
                            ? "main-container-of-all-employees-AdminDSR"
                            : "main-container-of-all-employees-page-new-AdminDSR"
                    }
                >
                    {/* Header Section */}
                    <div className="inner-container-of-all-employees-page">
                        <div className="header-of-employees-page">
                            <div className="all-employee-AdminDSR">
                                <h4>Admin DSR</h4>
                            </div>
                            <div className="all-employees-AdminDSR">
                                <div className="home-icon-AdminDSR">
                                    <BiHomeAlt className="home-icon-header-AdminDSR" />
                                </div>
                                <div className="arrow-icon-AdminDSR">
                                    <MdKeyboardArrowRight />
                                </div>
                                <div className="employee-text-AdminDSR">
                                    <p>DSR Management</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tabs Section */}
                    <div className="tabs-section-AdminDSR">
                        <button
                            className={`tab-button ${activeTab === "home" ? "active" : ""}`}
                            onClick={() => handleTabChange("home")}
                        >
                            Home
                        </button>
                        <button
                            className={`tab-button ${activeTab === "report" ? "active" : ""}`}
                            onClick={() => handleTabChange("report")}
                        >
                            Generate Monthly Report
                        </button>
                        <button
                            className={`tab-button ${activeTab === "dsr" ? "active" : ""}`}
                            onClick={() => handleTabChange("dsr")}
                        >
                            Show Employee DSR
                        </button>
                    </div>

                    <div className="body-part-outer-AdminDSR">
                        {/* HOME TAB */}
                        {activeTab === "home" && (
                            <>
                                <div className="inner-body-container-of-employee-AdminDSR row-12">
                                    <div className="first-side-in-body-AdminDSR">
                                        <select
                                            value={selectFilter}
                                            onChange={(e) => setSelectFilter(e.target.value)}
                                            className="select-dropdown-AdminDSR"
                                        >
                                            <option value="name">Name</option>
                                            <option value="type">Project Type</option>
                                            <option value="assignedUser">Assigned User</option>
                                        </select>

                                        <div className="input-for-search-in-employee-AdminDSR">
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </div>

                                        <button
                                            className="add-button-AdminDSR"
                                            onClick={() => openModal("addProject")}
                                        >
                                            <FiPlus /> Add Project
                                        </button>
                                    </div>
                                </div>

                                {/* Projects Table */}
                                <div className="table-in-all-emplyee-AdminDSR">
                                    <table className="table-main-AdminDSR">
                                        <thead className="thead-main-AdminDSR">
                                            <tr>
                                                {/* <th>
                                                    <input type="checkbox" />
                                                </th> */}
                                                <th>Name</th>
                                                <th>Project Type</th>
                                                <th>Assigned User</th>
                                                <th>Project Notes</th>
                                                <th>Project Documents</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="tbody-main-AdminDSR">
                                            {displayData.length > 0 ? (
                                                displayData.map((item, index) => {
                                                    const notesUrl = item.projectNotesFile;
                                                    const docsArr = item.projectDocuments;
                                                    return (
                                                        <tr key={item.id}>
                                                            {/* <td>
                                                                <input type="checkbox" />
                                                            </td> */}
                                                            <td>{item.name}</td>
                                                            <td>{item.type}</td>
                                                            <td>{item.assignedUserName}</td>
                                                            {/* Project Notes */}
                                                            <td>
                                                                {notesUrl ? (
                                                                    <>
                                                                        <button className="icon-btn-AdminDSR" title="View Notes" style={{ marginRight: 4 }} onClick={() => handleViewNotes(notesUrl)}>
                                                                            <AiOutlineEye />
                                                                        </button>
                                                                        <button className="icon-btn-AdminDSR" title="Download Notes" onClick={() => handleDownloadNotes(notesUrl)}>
                                                                            <AiOutlineDownload />
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    "---"
                                                                )}
                                                            </td>
                                                            {/* Project Documents */}
                                                            <td>
                                                                {(docsArr && docsArr.length > 0) || notesUrl ? (
                                                                    <>
                                                                        <button className="icon-btn-AdminDSR" title="View Documents" style={{ marginRight: 4 }} onClick={() => handleViewDocs(docsArr)}>
                                                                            <AiOutlineEye />
                                                                        </button>
                                                                        <button
                                                                            className="icon-btn-AdminDSR"
                                                                            title="Download All Documents"
                                                                            onClick={() => handleDownloadAllDocuments(docsArr)}
                                                                        >
                                                                            <AiOutlineDownload />
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    "---"
                                                                )}
                                                            </td>
                                                            <td>
                                                                <button
                                                                    className="edit-button-AdminDSR"
                                                                    onClick={() => openModal("addProject", item)}
                                                                >
                                                                    Edit
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="7">No record found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {/* Project Notes Modal */}
                                <Modal show={showNotesModal} onHide={() => setShowNotesModal(false)} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>Project Notes</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body style={{ height: '80vh' }}>
                                        {notesUrl ? (
                                            <iframe src={notesUrl} title="Project Notes" style={{ width: '100%', height: '100%', border: 'none' }} />
                                        ) : (
                                            <div>No notes available.</div>
                                        )}
                                    </Modal.Body>
                                </Modal>
                            </>
                        )}

                        {/* Project Documents Modal */}
                        <Modal
                            show={showDocsModal}
                            onHide={() => setShowDocsModal(false)}
                            size="lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Project Documents</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                {docsList.length > 0 ? (
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>File Name</th>
                                                <th style={{ width: "120px" }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {docsList.map((doc, index) => (
                                                <tr key={index}>
                                                    <td>{doc.fileName}</td>
                                                    <td>
                                                        <button
                                                            className="icon-btn-AdminDSR"
                                                            title="Preview"
                                                            style={{ marginRight: 8 }}
                                                            onClick={() => handlePreviewSingleDoc(doc.url)}
                                                        >
                                                            <AiOutlineEye />
                                                        </button>

                                                        <button
                                                            className="icon-btn-AdminDSR"
                                                            title="Download"
                                                            onClick={() => handleDownloadSingleDoc(doc.url, doc.fileName)}
                                                        >
                                                            <AiOutlineDownload />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                ) : (
                                    <div>No documents available</div>
                                )}
                            </Modal.Body>
                        </Modal>

                        {/* GENERATE MONTHLY REPORT TAB */}
                        {activeTab === "report" && (
                            <>
                                <div className="filters-section-AdminDSR">
                                    <div className="filter-group-AdminDSR">
                                        <label>From Date</label>
                                        <input
                                            type="date"
                                            className="date-input-AdminDSR"
                                            value={reportFilters.fromDate}
                                            onChange={(e) =>
                                                setReportFilters({ ...reportFilters, fromDate: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="filter-group-AdminDSR">
                                        <label>To Date</label>
                                        <input
                                            type="date"
                                            className="date-input-AdminDSR"
                                            value={reportFilters.toDate}
                                            onChange={(e) =>
                                                setReportFilters({ ...reportFilters, toDate: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="filter-group-AdminDSR">
                                        <label>Select Project</label>
                                        <select
                                            className="select-dropdown-AdminDSR"
                                            value={reportFilters.projectId}
                                            onChange={(e) =>
                                                setReportFilters({ ...reportFilters, projectId: e.target.value })
                                            }
                                        >
                                            <option value="">Select</option>
                                            {projects.map((p) => (
                                                <option key={p.id} value={p.id}>
                                                    {p.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="filter-group-AdminDSR">
                                        <label>Employee</label>
                                        <select
                                            className="select-dropdown-AdminDSR"
                                            value={reportFilters.userId}
                                            onChange={(e) =>
                                                setReportFilters({ ...reportFilters, userId: e.target.value })
                                            }
                                        >
                                            <option value="">Select</option>
                                            {employees.map((e) => (
                                                <option key={e.id} value={e.id}>
                                                    {e.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <button
                                            className="search-button-AdminDSR"
                                            onClick={fetchMonthlyReport}
                                        >
                                            Search
                                        </button>

                                        <button
                                            className="cancel-button-AdminDSR"
                                            onClick={handleReportReset}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>

                                {/* Monthly Report Table */}
                                <div className="table-in-all-emplyee-AdminDSR">
                                    <table className="table-main-AdminDSR">
                                        <thead className="thead-main-AdminDSR">
                                            <tr>
                                                <th>#</th>
                                                <th>Project Name</th>
                                                <th>Employee Name</th>
                                                <th>Time</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="tbody-main-AdminDSR">
                                            {monthlyReportData.length > 0 ? (
                                                monthlyReportData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.ProjectName}</td>
                                                        <td>{item.UserName}</td>
                                                        <td>{item.TotalTime}</td>
                                                        <td>
                                                            <button
                                                                className="view-button-AdminDSR"
                                                                onClick={() => fetchTasksForAdmin(item)}
                                                            >
                                                                View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5">No record found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {reportFilters.projectId && !reportFilters.userId && monthlyReportData.length > 0 && (
                                    <div style={{
                                        marginTop: "15px",
                                        textAlign: "center",
                                        fontWeight: "600",
                                        fontSize: "16px"
                                    }}>
                                        Project Total Time: {calculateTotalTime()}
                                    </div>
                                )}
                            </>
                        )}

                        {/* SHOW EMPLOYEE DSR TAB */}
                        {activeTab === "dsr" && (
                            <>
                                <div className="filters-section-AdminDSR">
                                    <div className="filter-group-AdminDSR">
                                        <label>From Date</label>
                                        <input
                                            type="date"
                                            className="date-input-AdminDSR"
                                            value={dsrFilters.fromDate}
                                            onChange={(e) =>
                                                setDsrFilters({ ...dsrFilters, fromDate: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="filter-group-AdminDSR">
                                        <label>To Date</label>
                                        <input
                                            type="date"
                                            className="date-input-AdminDSR"
                                            value={dsrFilters.toDate}
                                            onChange={(e) =>
                                                setDsrFilters({ ...dsrFilters, toDate: e.target.value })
                                            }
                                        />
                                    </div>
                                    <div className="filter-group-AdminDSR">
                                        <label>Select Project</label>
                                        <select
                                            className="select-dropdown-AdminDSR"
                                            value={dsrFilters.projectId}
                                            onChange={(e) =>
                                                setDsrFilters({ ...dsrFilters, projectId: e.target.value })
                                            }
                                        >
                                            <option>Select</option>
                                            {projects.map((p) => (
                                                <option key={p.id} value={p.id}>
                                                    {p.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="filter-group-AdminDSR">
                                        <label>Select Employee</label>
                                        <select
                                            className="select-dropdown-AdminDSR"
                                            value={dsrFilters.userId}
                                            onChange={(e) =>
                                                setDsrFilters({ ...dsrFilters, userId: e.target.value })
                                            }
                                        >
                                            <option>Select</option>
                                            {employees.map((e) => (
                                                <option key={e.id} value={e.id}>
                                                    {e.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <button
                                            className="search-button-AdminDSR"
                                            onClick={fetchEmployeeDsr}
                                        >
                                            Search
                                        </button>

                                        <button
                                            className="cancel-button-AdminDSR"
                                            onClick={handleDsrReset}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>

                                {/* DSR Table */}
                                <div className="table-in-all-emplyee-AdminDSR">
                                    <table className="table-main-AdminDSR">
                                        <thead className="thead-main-AdminDSR">
                                            <tr>
                                                <th>#</th>
                                                <th>Date</th>
                                                <th>Employee</th>
                                                <th>Project Name</th>
                                                <th>Task</th>
                                                <th>Hour</th>
                                                <th>Edit / Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody className="tbody-main-AdminDSR">
                                            {employeeDsrData.length > 0 ? (
                                                employeeDsrData.map((item, index) => (
                                                    <tr key={item.id}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.date}</td>
                                                        <td>{item.employee}</td>
                                                        <td>{item.project}</td>
                                                        <td>{item.task}</td>
                                                        <td>{item.hours}</td>
                                                        <td className="action-buttons-AdminDSR">
                                                            <button
                                                                className="edit-icon-button-AdminDSR"
                                                                onClick={() => openModal("editDSR", item)}
                                                            >
                                                                <FiEdit2 />
                                                            </button>
                                                            <button
                                                                className="delete-icon-button-AdminDSR"
                                                                onClick={() => {
                                                                    setDeleteId(item.id);
                                                                    setShowDeleteModal(true);
                                                                }}
                                                            >
                                                                <FiTrash2 />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7">No record found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* ADD/EDIT PROJECT MODAL */}
            {showModal && modalType === "addProject" && (
                <div className="modal-overlay-AdminDSR">
                    <div className="modal-content-AdminDSR">
                        <div className="modal-header-AdminDSR">
                            <h3>Project Information</h3>
                            <button onClick={closeModal} className="close-button-AdminDSR">
                                <AiOutlineClose />
                            </button>
                        </div>
                        <div className="modal-body-AdminDSR">
                            <div className="form-group-AdminDSR">
                                <label>Project Name:</label>
                                <input
                                    type="text"
                                    placeholder="Enter Project Name"
                                    value={formData.ProjectName || ""}
                                    onChange={(e) =>
                                        setFormData({ ...formData, ProjectName: e.target.value })
                                    }
                                />
                            </div>
                            <div className="form-group-AdminDSR">
                                <label>Project Type:</label>
                                <select
                                    value={formData.ProjectType || ""}
                                    onChange={(e) =>
                                        setFormData({ ...formData, ProjectType: e.target.value })
                                    }
                                >
                                    <option value="">Select</option>
                                    {projectTypes.map((type) => (
                                        <option key={type.Id} value={type.Id}>
                                            {type.ProjectType1}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group-AdminDSR">
                                <label>Assign User:</label>
                                <select
                                    value={formData.AssignedUserId || ""}
                                    onChange={(e) =>
                                        setFormData({ ...formData, AssignedUserId: e.target.value })
                                    }
                                >
                                    <option value="">Select User</option>
                                    {employees.map((emp) => (
                                        <option key={emp.id} value={emp.id}>
                                            {emp.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group-AdminDSR">
                                <label>Project Notes:</label>
                                {/* SHOW EXISTING NOTES */}
                                {formData.ExistingProjectNotesFile && (
                                    <div style={{ marginBottom: "10px" }}>
                                        <strong>Existing Notes:</strong>

                                        <div>
                                            <button
                                                type="button"
                                                onClick={() => handleViewNotes(formData.ExistingProjectNotesFile)}
                                                className="icon-btn-AdminDSR"
                                                style={{ marginRight: 8 }}
                                            >
                                                View
                                            </button>

                                            <button
                                                type="button"
                                                onClick={() => handleDownloadNotes(formData.ExistingProjectNotesFile)}
                                                className="icon-btn-AdminDSR"
                                            >
                                                Download
                                            </button>
                                        </div>
                                    </div>
                                )}
                                <ReactQuill
                                    theme="snow"
                                    value={formData.ProjectNoteHtmlContent || ""}
                                    onChange={(value) =>
                                        setFormData({
                                            ...formData,
                                            ProjectNoteHtmlContent: value
                                        })
                                    }
                                    style={{ height: "200px", marginBottom: "40px" }}
                                />
                            </div>
                            <div className="form-group-AdminDSR">
                                <label>Project Documents (Multiple Files):</label>
                                {/* SHOW EXISTING DOCUMENTS */}
                                {formData.ExistingProjectDocuments &&
                                    formData.ExistingProjectDocuments.length > 0 && (
                                        <div style={{ marginBottom: "10px" }}>
                                            <strong>Existing Documents:</strong>

                                            {formData.ExistingProjectDocuments.map((doc, index) => {
                                                const fullUrl = doc.ProjectDoument?.startsWith("http")
                                                    ? doc.ProjectDoument
                                                    : FILE_PREFIX + doc.ProjectDoument;

                                                const fileName =
                                                    doc.ProjectDoument?.split("\\").pop().split("/").pop();

                                                return (
                                                    <div key={index} style={{ marginBottom: "5px" }}>
                                                        {fileName}

                                                        <button
                                                            type="button"
                                                            style={{ marginLeft: 10, marginRight: 5 }}
                                                            onClick={() => window.open(fullUrl, "_blank")}
                                                        >
                                                            View
                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={() => downloadFile(fullUrl, fileName)}
                                                        >
                                                            Download
                                                        </button>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}

                                <input
                                    type="file"
                                    multiple
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            ProjectDocumentsFiles: Array.from(e.target.files)
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="modal-footer-AdminDSR">
                            <button className="save-button-AdminDSR" onClick={handleFormSubmit}>
                                Save
                            </button>
                            <button className="cancel-button-AdminDSR" onClick={closeModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* EDIT DSR MODAL */}
            {showModal && modalType === "editDSR" && (
                <div className="modal-overlay-AdminDSR">
                    <div className="modal-content-AdminDSR">
                        <div className="modal-header-AdminDSR">
                            <h3>Edit DSR</h3>
                            <button onClick={closeModal} className="close-button-AdminDSR">
                                <AiOutlineClose />
                            </button>
                        </div>

                        <div className="modal-body-AdminDSR">

                            <div className="form-row-AdminDSR">
                                <div className="form-group-AdminDSR">
                                    <label>Date *</label>
                                    <input
                                        type="date"
                                        value={formData.date || ""}
                                        onChange={(e) =>
                                            setFormData({ ...formData, date: e.target.value })
                                        }
                                    />
                                </div>

                                <div className="form-group-AdminDSR">
                                    <label>Project *</label>
                                    <select
                                        value={formData.projectId || ""}
                                        onChange={(e) =>
                                            setFormData({ ...formData, projectId: e.target.value })
                                        }
                                    >
                                        <option value="">Select</option>
                                        {projects.map((p) => (
                                            <option key={p.id} value={p.id}>
                                                {p.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="form-row-AdminDSR">
                                <div className="form-group-AdminDSR">
                                    <label>Employee *</label>
                                    <input
                                        type="text"
                                        value={formData.employeeName || ""}
                                        readOnly
                                    />
                                </div>

                                <div className="form-group-AdminDSR">
                                    <label>Hours *</label>
                                    <input
                                        type="number"
                                        value={formData.hours || ""}
                                        onChange={(e) =>
                                            setFormData({ ...formData, hours: e.target.value })
                                        }
                                    />
                                </div>
                            </div>

                            <div className="form-row-AdminDSR">
                                <div className="form-group-AdminDSR">
                                    <label>Minutes *</label>
                                    <input
                                        type="number"
                                        value={formData.minutes || ""}
                                        onChange={(e) =>
                                            setFormData({ ...formData, minutes: e.target.value })
                                        }
                                    />
                                </div>
                            </div>

                            <div className="form-group-AdminDSR">
                                <label>Task Detail *</label>
                                <textarea
                                    rows="4"
                                    value={formData.task || ""}
                                    onChange={(e) =>
                                        setFormData({ ...formData, task: e.target.value })
                                    }
                                />
                            </div>
                        </div>

                        <div className="modal-footer-AdminDSR">
                            <button className="save-button-AdminDSR" onClick={handleUpdateTask}>
                                UPDATE
                            </button>
                            <button className="cancel-button-AdminDSR" onClick={closeModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* TASK DETAILS MODAL */}
            {showTaskModal && (
                <div className="modal-overlay-AdminDSR">
                    <div className="modal-content-task-AdminDSR">
                        <div className="modal-header-AdminDSR">
                            <h3>Task Details</h3>
                            <button onClick={() => setShowTaskModal(false)} className="close-button-AdminDSR">
                                <AiOutlineClose />
                            </button>
                        </div>
                        <div className="modal-body-task-AdminDSR">
                            <div className="task-info-row-AdminDSR">
                                <div className="task-info-field-AdminDSR">
                                    <label>Project Name</label>
                                    <input type="text" value={taskModalData?.projectName || ""} readOnly />
                                </div>
                                <div className="task-info-field-AdminDSR">
                                    <label>Employee Name</label>
                                    <input type="text" value={taskModalData?.employeeName || ""} readOnly />
                                </div>
                            </div>
                            <div className="task-info-row-AdminDSR">
                                <div className="task-info-field-AdminDSR">
                                    <label>From Date</label>
                                    <input type="text" value={reportFilters.fromDate}
                                        readOnly />
                                </div>
                                <div className="task-info-field-AdminDSR">
                                    <label>To Date</label>
                                    <input type="text" value={reportFilters.toDate}
                                        readOnly />
                                </div>
                            </div>
                            <div className="task-entries-AdminDSR">
                                <label>Show <select><option>10</option></select> entries</label>
                                <div className="search-in-task-AdminDSR">
                                    <label>Search:</label>
                                    <input
                                        type="text"
                                        value={taskSearch}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setTaskSearch(value);

                                            const filtered = taskList.filter(task =>
                                                task.task.toLowerCase().includes(value.toLowerCase())
                                            );

                                            setFilteredTaskList(filtered);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="table-in-all-emplyee-AdminDSR">
                                <table className="table-main-AdminDSR">
                                    <thead className="thead-main-AdminDSR">
                                        <tr>
                                            <th>#</th>
                                            <th>Date</th>
                                            <th>Task</th>
                                            <th>Time</th>
                                        </tr>
                                    </thead>
                                    <tbody className="tbody-main-AdminDSR">
                                        {filteredTaskList.length > 0 ? (
                                            filteredTaskList.map((task, idx) => (
                                                <tr key={task.id}>
                                                    <td>{idx + 1}</td>
                                                    <td>{task.date}</td>
                                                    <td>{task.task}</td>
                                                    <td>{task.time}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4">No tasks found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="pagination-AdminDSR">
                                <button>Previous</button>
                                <button>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* DELETE CONFIRMATION MODAL */}
            {showDeleteModal && (
                <div className="modal-overlay-AdminDSR">
                    <div className="modal-content-AdminDSR">
                        <div className="modal-header-AdminDSR">
                            <h3>Confirm Delete</h3>
                            <button
                                onClick={handleDeleteCancel}
                                className="close-button-AdminDSR"
                            >
                                <AiOutlineClose />
                            </button>
                        </div>

                        <div className="modal-body-AdminDSR">
                            <p style={{ textAlign: "center", fontSize: "16px" }}>
                                Are you sure you want to delete this record?
                            </p>
                        </div>

                        <div className="modal-footer-AdminDSR">
                            <button
                                className="save-button-AdminDSR"
                                onClick={handleDeleteConfirm}
                                style={{ backgroundColor: "#dc3545" }}
                            >
                                Yes, Delete
                            </button>

                            <button
                                className="cancel-button-AdminDSR"
                                onClick={handleDeleteCancel}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AdminDSR;